import { Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

import { breakpointLargeTablet } from 'src/styles/breakpoints';
import { colorNeutral, colorSecondary800 } from 'src/styles/colors';
import { spacing1, spacing2, spacing3 } from 'src/styles/spacing';

export const StyledFooterUserInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: ${spacing3} 0;
  background: ${colorSecondary800};

  @media (min-width: ${breakpointLargeTablet}) {
    flex-direction: row;
  }
`;

export const StyledFooterText = styled(Typography)`
  color: ${colorNeutral};

  &:not(:last-child) {
    margin: 0 0 ${spacing1} 0;
  }

  @media (min-width: ${breakpointLargeTablet}) {
    &:not(:last-child) {
      margin: 0;
    }

    &:not(:last-child)::after {
      content: '/';
      padding: 0 ${spacing2};
    }
  }
`;
